export default __webpack_public_path__ + "2c88e3b1ada4b409524d12c3471f000e.png";